import axios from "axios";
import { useEffect, useState } from "react";
import { AgenticPageService } from "../services/AgenticPageService";
import { PageMetadata } from "../models/PageMetadata";

const agenticPagesSvc = new AgenticPageService();

/**
 * Effective tags + expedition of a page. Pass something that changes when the page is saved (e.g. its
 * dateModified) as `version` to refetch. Failures are silent: the header simply shows no metadata.
 */
export function usePageMetadata(pageId: string | undefined, version?: string): PageMetadata | undefined {
    const [metadata, setMetadata] = useState<PageMetadata>();

    useEffect(() => {
        setMetadata(undefined);
        if (!pageId) return;

        const source = axios.CancelToken.source();
        agenticPagesSvc
            .getPageMetadata(pageId, source.token)
            .then(setMetadata)
            .catch(() => setMetadata(undefined));

        return () => source.cancel();
    }, [pageId, version]);

    return metadata;
}
